/* import __COLOCATED_TEMPLATE__ from './user-summary-category-search.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import discourseComputed from "discourse-common/utils/decorators";
import TEMPLATE from "./user-summary-category-search.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend(dt7948.p({
  tagName: "",
  searchParams() {
    return `@${this.get("user.username")} #${this.get("category.slug")}`;
  }
}, [["method", "searchParams", [discourseComputed("user", "category")]]])));